// extracted by mini-css-extract-plugin
module.exports = {"search-wrap":"style_search-wrap__2d3ks","toggle":"style_toggle__1YTVd"};